import { Link } from "react-router-dom";
import { PRODUCTS } from "../../../mocks/products";
import { useCart } from "../../../contexts/CartContext";

const FEATURED = PRODUCTS.slice(0, 3);

function StarRating({ rating }: { rating: number }) {
  return (
    <div className="flex items-center gap-0.5">
      {[1, 2, 3, 4, 5].map((s) => (
        <i
          key={s}
          className={`text-xs ${
            s <= Math.round(rating) ? "ri-star-fill text-amber-400" : "ri-star-line text-zinc-300"
          }`}
        />
      ))}
    </div>
  );
}

export default function FeaturedProducts() {
  const { addItem } = useCart();

  return (
    <section className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        {/* Header */}
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-6 mb-12">
          <div>
            <p className="text-xs tracking-widest text-zinc-400 uppercase mb-3">Featured Products</p>
            <h2 className="text-4xl md:text-5xl font-extralight text-[#1B4332] tracking-tight">
              精選商品
            </h2>
          </div>
          <Link
            to="/shop"
            className="inline-flex items-center gap-2 text-sm text-[#1B4332] font-medium tracking-wider border-b border-[#1B4332] pb-0.5 hover:opacity-60 transition-opacity duration-200 cursor-pointer whitespace-nowrap self-start md:self-auto"
          >
            查看全部商品 <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        {/* Products */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {FEATURED.map((product, index) => (
            <div
              key={product.id}
              className={`group cursor-pointer ${index === 1 ? "md:mt-8" : ""}`}
            >
              {/* Image */}
              <div className="relative overflow-hidden bg-zinc-50 rounded-lg mb-5" style={{ aspectRatio: "4/5" }}>
                <img
                  src={product.image}
                  alt={product.name}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                {/* Discount badge */}
                <div className="absolute top-4 left-4 w-12 h-12 flex items-center justify-center bg-[#1B4332] text-white text-xs font-bold rounded-full">
                  -{product.discount}%
                </div>
                {/* Add to cart button */}
                <button
                  onClick={() => addItem(product)}
                  className="absolute bottom-4 right-4 w-11 h-11 flex items-center justify-center bg-white text-[#1B4332] rounded-full opacity-0 group-hover:opacity-100 hover:bg-[#1B4332] hover:text-white transition-all duration-300 shadow-lg cursor-pointer"
                >
                  <i className="ri-shopping-bag-line text-base"></i>
                </button>
              </div>

              {/* Info */}
              <div>
                <p className="text-[10px] text-zinc-400 tracking-widest uppercase mb-1">{product.brand}</p>
                <h3 className="text-[#1B4332] font-medium text-base leading-snug mb-2 line-clamp-2">
                  {product.name}
                </h3>
                <div className="flex items-center justify-between mb-3">
                  <StarRating rating={product.rating} />
                  <span className="text-xs text-zinc-400">({product.reviewCount.toLocaleString()})</span>
                </div>
                <div className="flex items-center gap-3">
                  <span className="text-[#1B4332] text-lg font-semibold">
                    NT$ {product.price.toLocaleString()}
                  </span>
                  <span className="text-zinc-400 text-sm line-through">
                    NT$ {product.originalPrice.toLocaleString()}
                  </span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
